/**
 * Cart Upsell Carousel
 * - Variant select: updates hidden input + displayed price
 * - Add-to-cart animation: triggers the checkmark burst on submit
 * - Prevents slideshow drag from blocking interactive elements (select, button)
 * - Re-initializes slideshow after cart morph updates (cart:update)
 * Carousel behaviour is handled by the theme's native slideshow-component.
 */

/*
 * Stop mousedown from reaching the slideshow's drag handler
 * on interactive elements. The slideshow calls event.preventDefault()
 * on all mousedowns which blocks native <select> from opening.
 */
document.addEventListener(
  'mousedown',
  (e) => {
    if (e.target.closest('.mp-cart-upsell__card select, .mp-cart-upsell__card button, .mp-cart-upsell__card a, .mp-cart-upsell__card label')) {
      e.stopPropagation();
    }
  },
  true
);

/* Variant select (dropdown) */
document.addEventListener('change', (e) => {
  const select = e.target.closest('[data-upsell-variant-select]');
  if (!select) return;

  const card = select.closest('.mp-cart-upsell__card');
  if (!card) return;

  const selectedOption = select.options[select.selectedIndex];
  const variantInput = card.querySelector('input[name="id"]');
  const priceDisplay = card.querySelector('[data-upsell-price-display]');

  if (variantInput) {
    variantInput.value = select.value;
  }

  if (priceDisplay && selectedOption) {
    priceDisplay.textContent = selectedOption.dataset.price;
  }

  const btnPrice = card.querySelector('[data-upsell-btn-price]');
  if (btnPrice && selectedOption) {
    btnPrice.textContent = selectedOption.dataset.price;
  }
});

/* Variant radio buttons */
document.addEventListener('change', (e) => {
  const radio = e.target.closest('[data-upsell-variant-radio]');
  if (!radio) return;

  const card = radio.closest('.mp-cart-upsell__card');
  if (!card) return;

  const variantInput = card.querySelector('input[name="id"]');
  const priceDisplay = card.querySelector('[data-upsell-price-display]');

  if (variantInput) {
    variantInput.value = radio.value;
  }

  if (priceDisplay) {
    priceDisplay.textContent = radio.dataset.price;
  }

  const btnPrice = card.querySelector('[data-upsell-btn-price]');
  if (btnPrice) {
    btnPrice.textContent = radio.dataset.price;
  }
});

/* Sync arrow visibility based on scroll position */
function syncUpsellArrows() {
  const container = document.querySelector('.mp-cart-upsell slideshow-component');
  if (!container) return;

  const prev = container.querySelector('slideshow-arrows .slideshow-control:first-child');
  const next = container.querySelector('slideshow-arrows .slideshow-control:last-child');
  const slides = container.querySelectorAll('slideshow-slide');

  if (!prev || !next || slides.length <= 1) return;

  const scroller = container.querySelector('slideshow-slides');
  if (!scroller) return;

  const scrollLeft = scroller.scrollLeft;
  const isAtStart = scrollLeft <= 5;
  const isAtEnd = scrollLeft + scroller.clientWidth >= scroller.scrollWidth - 5;

  prev.disabled = isAtStart;
  next.disabled = isAtEnd;
}

/*
 * Re-initialize the slideshow after cart morph updates.
 *
 * When morphSection() runs, it compares server HTML (no [in-viewport] attr)
 * with the live DOM ([in-viewport] set by JS). The morph removes the attr,
 * causing overflow:hidden on slideshow-slides — killing swipe & arrows.
 *
 * The CSS override in the snippet handles the overflow, but the slideshow's
 * internal state (IntersectionObserver for slides, current index) also goes
 * stale because the morph swaps slide elements that the observer doesn't track.
 *
 * Fix: remove and re-insert the slideshow-component to trigger a full
 * disconnectedCallback (cleanup) → connectedCallback (fresh init) cycle.
 */
function reinitUpsellSlideshow() {
  const slideshow = document.querySelector('.mp-cart-upsell slideshow-component');
  if (!slideshow || !slideshow.parentNode) return;

  const parent = slideshow.parentNode;
  const next = slideshow.nextSibling;

  /* Remove triggers disconnectedCallback — cleans up Scroller, observers, listeners */
  slideshow.remove();

  /* Re-insert on next frame so the browser processes the disconnect first */
  requestAnimationFrame(() => {
    parent.insertBefore(slideshow, next);
    /* Ensure scrolling is enabled immediately — the SlideshowViewportObserver
       won't re-fire because the intersection state hasn't changed */
    slideshow.setAttribute('in-viewport', '');

    requestAnimationFrame(() => syncUpsellArrows());
  });
}

/* Listen for cart updates (fires after morphSection completes) */
document.addEventListener('cart:update', () => {
  /* Double rAF ensures the morph has finished and the DOM is settled */
  requestAnimationFrame(() => {
    requestAnimationFrame(() => {
      reinitUpsellSlideshow();
    });
  });
});

/* Sync arrows after scroll ends */
document.addEventListener('scrollend', (e) => {
  if (e.target.closest?.('.mp-cart-upsell slideshow-slides')) {
    syncUpsellArrows();
  }
}, true);

/* Add-to-cart animation on submit */
document.addEventListener('submit', (e) => {
  const card = e.target.closest('.mp-cart-upsell__card');
  if (!card) return;

  const btn = card.querySelector('.mp-cart-upsell__add-btn');
  if (!btn || btn.dataset.added === 'true') return;

  btn.dataset.added = 'true';

  setTimeout(() => {
    btn.dataset.added = 'false';
  }, 2000);
});
